module.exports = __webpack_public_path__ + "static/media/culture_worth.37dc215d.png";